import React from 'react';
import { connect } from 'react-redux';
import Translation from '../../utilities/localizationUtility';
import { addItems } from '../../actions/cart';
import Submit from './Submit';

function Index(props) {
  const { addItemsToCart, variants = [], order: { variantSelected, quantity = 1 } } = props;
  const t = new Translation(props);
  let inventoryLevels = [];
  const variant = variants.find((v) => v.external_id === variantSelected);
  if (variant) inventoryLevels = variant.inventory_levels || [];
  let canBook = inventoryLevels.length === 0 || inventoryLevels.every((level) => level.available === null);
  if (!canBook) canBook = Math.max.apply(Math, inventoryLevels.map((level) => level.available)) >= quantity;
  const label = canBook ? t.key('submitForHiddenVariants') || 'Add to cart' : t.key('noAvailability');

  return (
    <Submit
      label={label}
      className="submit"
      canBook={canBook}
      onSubmit={() => addItemsToCart({
        items: [{ external_id: variantSelected, quantity }],
      })}
    />
  );
}

export default connect(
  ({ order, product, settings }) => ({
    order,
    variants: product.data.variants,
    translation: settings.translation,
    defaultTranslation: settings.translation,
  }),
  (dispatch) => ({
    addItemsToCart: (value) => dispatch(addItems(value)),
  }),
)(Index);
